<template>
 
             
          <div class="w3-card-4" v-if="newversionavailable || addtohomescreen || !location || !fcmToken || fcmToken==='errornotoken'">
                <header class="w3-container w3-theme-d2">
                    <h3>Your Options</h3>
                </header>
                <div style="padding:10px">                           
                    <large-button v-if="addtohomescreen" class="w3-theme-dark" @click="addToHomeScreen()">Add To Home</large-button>   

                    <large-button v-if="!location" class="w3-theme-dark" @click="setCurrentLocation()">Set Location <i class="fa fa-map-marker"/></large-button>   

                    <large-button v-if="!fcmToken || fcmToken==='errornotoken'" class="w3-theme-dark" @click="setNotifications()">Set Notifications</large-button> 

                    <large-button v-if="newversionavailable" class="w3-theme-dark" @click="unRegister()">Updates available</large-button>

                </div>

                <footer class="w3-small" v-if="addtohomescreen" style="padding:10px">Click add to Home to create a short cut on your home screen. This provides a nicer experience like a normal mobile or PC app without installing anything at all.</footer>
                <footer class="w3-small" v-if="!location"  style="padding:10px">Click to set your location, this helps with letting the vendor know where your remedial work is located.</footer>                
                <footer class="w3-small" v-if="!fcmToken || fcmToken==='errornotoken'"  style="padding:10px">Turn on notifications, this allows direct notices about your orders to be sent to you, handy if you phone is locked or application window is not visible.</footer>                
                <footer class="w3-small" v-if="newversionavailable"  style="padding:10px">A new version is available that offers more enhancements and bug fixes. Click to get these changes.</footer>                

          </div>       
    

    
    
</template>


<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: "Home",
    methods:{
      ...mapActions(['addToHomeScreen','setCurrentLocation','setNotifications','unRegister'])
    },
    computed: mapGetters(["addtohomescreen","location","fcmToken","newversionavailable"])
  };
</script>



// WEBPACK FOOTER //
// src/components/home/OptionsTile.vue